import { render, staticRenderFns } from "./Layout1x1.vue?vue&type=template&id=42115f92&scoped=true&"
import script from "./Layout1x1.vue?vue&type=script&lang=js&"
export * from "./Layout1x1.vue?vue&type=script&lang=js&"
import style0 from "./Layout1x1.vue?vue&type=style&index=0&id=42115f92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42115f92",
  null
  
)

export default component.exports